import { render, staticRenderFns } from "./cusSaleStat.vue?vue&type=template&id=18cbb1ab&scoped=true&"
import script from "./cusSaleStat.vue?vue&type=script&lang=js&"
export * from "./cusSaleStat.vue?vue&type=script&lang=js&"
import style0 from "./cusSaleStat.vue?vue&type=style&index=0&id=18cbb1ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbb1ab",
  null
  
)

component.options.__file = "cusSaleStat.vue"
export default component.exports